// Swaps the dropdown's card set to the hovered/focused sub-item; falls back to the default set.
if (!customElements.get('menu-hover-cards')) {
  customElements.define(
    'menu-hover-cards',
    class MenuHoverCards extends HTMLElement {
      connectedCallback() {
        // Element is display: contents, so leave is tracked on the dropdown box itself
        this.dropdown = this.parentElement;
        this.onActivate = (event) => {
          const trigger = event.target.closest('[data-menu-cards-trigger]');
          if (trigger && this.contains(trigger)) this.show(trigger);
        };
        this.onReset = () => this.show(null);
        // Touch has no hover: the first tap on a sub-item with its own cards previews them, the second follows the link
        this.onPointerDown = (event) => {
          const trigger = event.target.closest('[data-menu-cards-trigger]');
          this.tapWasCurrent = trigger?.classList.contains('submenu-item--current') ?? null;
        };
        this.onClick = (event) => {
          const trigger = event.target.closest('[data-menu-cards-trigger]');
          const wasCurrent = this.tapWasCurrent;
          this.tapWasCurrent = null;
          if (!trigger || !this.contains(trigger) || wasCurrent !== false || !this.panelFor(trigger)) return;
          event.preventDefault();
          this.show(trigger);
        };

        this.addEventListener('focusin', this.onActivate);
        if (this.dataset.activation === 'tap') {
          this.addEventListener('pointerdown', this.onPointerDown);
          this.addEventListener('click', this.onClick);
        } else {
          this.addEventListener('pointerover', this.onActivate);
          this.dropdown.addEventListener('pointerleave', this.onReset);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('focusin', this.onActivate);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerover', this.onActivate);
        this.dropdown?.removeEventListener('pointerleave', this.onReset);
      }

      panelFor(trigger) {
        const key = trigger.dataset.menuCardsTrigger;
        return [...this.querySelectorAll('[data-menu-cards]')].find((panel) => panel.dataset.menuCards === key);
      }

      show(trigger) {
        const key = trigger?.dataset.menuCardsTrigger;
        const panels = this.querySelectorAll('[data-menu-cards]');
        const match = key ? [...panels].find((panel) => panel.dataset.menuCards === key) : null;
        const target = match || [...panels].find((panel) => panel.dataset.menuCards === 'default');

        panels.forEach((panel) => {
          panel.hidden = panel !== target;
        });
        this.querySelectorAll('[data-menu-cards-trigger]').forEach((item) => {
          item.classList.toggle('submenu-item--current', Boolean(match) && item === trigger);
        });
      }
    }
  );
}
